import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useResendVerificationEmail from "../hooks/useResendVerificationEmail";

const RegistrationSuccessNotice = ({ successMessage, email }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [cooldown, setCooldown] = useState(0); // seconds remaining
  const { resendEmail, response, error, loading } = useResendVerificationEmail();

  useEffect(() => {
    if (
      successMessage === "success" ||
      successMessage === "Data inserted successfully."
    ) {
      setShowSuccess(true);
    }
  }, [successMessage]);

  // Countdown timer
  useEffect(() => {
    let interval;
    if (cooldown > 0) {
      interval = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [cooldown]);

  const handleResendEmail = () => {
    if (email && cooldown === 0) {
      resendEmail(email);
      setCooldown(120); // 2 minutes
    }
  };

  // if (!showSuccess) return null;

  return (
    <div className="card">
      <div className="card-body">
        {/* Logo */}
        <div className="app-brand justify-content-center">
          <Link to={"/iusevolutione/login"} className="app-brand-link gap-2">
            <span className="app-brand-text demo text-body fw-bold text-uppercase">NOTARY PUBLIKO ✅</span>
          </Link>
        </div>

        <h3 className="mb-3 mt-4">Verify your email ✉️</h3>
        <p className="fw-medium fs-6">
          Account Created! 👏 <br/>
          We’ve sent a verification link to your email:{" "}
          <strong>{email || "your provided email"}</strong>. <br />
          Please check your inbox, all mails (and spam folder) and click the link to verify your
          account.
        </p>

     

          <p className="text-center mt-4">
              Didn't get the mail?
              <span
            onClick={handleResendEmail}
            className="text-primary"
            style={{ cursor: cooldown === 0 ? "pointer" : "not-allowed", opacity: cooldown === 0 ? 1 : 0.5 }}
          >
            {loading
              ? " Sending..."
              : cooldown > 0
              ? ` Resend in ${cooldown}s`
              : " Resend"}
          </span>
            </p>

          {response && <p className="mt-2 text-success">{response.message}</p>}
          {error && <p className="mt-2 text-danger">{error.message || error}</p>}
         
      </div>
    </div>
  );
};

export default RegistrationSuccessNotice;
